import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { Info } from "@livechat/design-system-icons";
import { SpacingToken } from "@livechat/design-system-react-components";

import { AutomationsEmptyState } from "routes/automations/shared/components/AutomationsEmptyState";
import { withVar } from "themes/helpers";

interface IProps {
  title: string;
  description: string | ReactNode;
  primaryAction: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  };
}

export const MacrosListEmptyState: FC<IProps> = ({
  title,
  description,
  primaryAction: { label, onClick, disabled = false },
}) => (
  <StyledAutomationsEmptyState
    title={title}
    description={description}
    primaryAction={{
      label,
      kind: "secondary",
      disabled,
      onClick,
      testId: "empty-state-cta-button",
    }}
    icon={Info}
  />
);

const StyledAutomationsEmptyState = styled(AutomationsEmptyState)`
  margin-top: ${withVar(SpacingToken.Spacing8)};
`;
